import ReconnectingWebSocket from 'reconnecting-websocket';
import f from './functions'
import moment from 'moment'
import { each } from 'underscore';

var WSS = function(p, url){
    var self = this

    var handledNotifications = {};
    var rws = null; 

    self.lastevent = null;
    
    self.state = {

        wssready : {
            v : false,
            set value(_v){
                this.v = _v

                p.vm.$store.commit('wssready', this.v)

            },

            get value(){
                return this.v
            }
        },

        opened : {
            v : false,
            set value(_v){
                this.v = _v
            },

            get value(){
                return this.v
            }
        },
    }

    var clbks = {

    }

    var authsend = function(message, clbk){
        if (p.user){

            return p.user.state.is().then(state => {

                if(state){

                    p.user.extendA(message.data || {}).then(data => {
                     
                        message.data = data

                        send(message, clbk);

                    })

                    return Promise.resolve()
                }

                return Promise.resolve()

            })

        }

        return Promise.reject()

    }

    var send = function(message, clbk){
      
        if (rws){
        
            f.retry(function(){

                return self.state.opened.value

            }, function(){

                if(!self.state.opened.value){
                    return
                }

                if (clbk){
                    message.id = p.f.makeid()
    
                    clbks[message.id] = clbk
                }
    
                try{
                    rws.send(JSON.stringify(message));
                }
                catch(e){
    
                }

            }, 20, 3000)
        }
    }

    var ping = function(clbk, timeout){

        if(!timeout) timeout = 500

        var resolved = false

        send({
            action : "ping"
        }, function(){
            resolved = true
        })

        f.retry(function(){

            return resolved

        }, function(){

            if(clbk) clbk(resolved)

        }, 20, timeout)

    }

    var registration = function(clbk){

        return authsend({
            action : 'registration'
        }, function(data){
            
            if (data.registered) {
                self.state.wssready.value = true
            }

            if(clbk) clbk()
        })
       
    }

    var signout = function(clbk){

        return authsend({
            action : 'signout'
        }, clbk)

    }

    var handleMessages = function(_message){
        var message = {}

        self.lastevent = new Date()

        if (p.platform.onlineListener) {
            p.platform.onlineListener.makeclbks('offline')
        }

        if(_.isObject(_message)){
            message = _.clone(_message)
        }
        else{
            try{    
                message = JSON.parse(_message)
            }
    
            catch(e){
                

            }
        }

        if(message == '1') return
        

        if(!message.data){
            message.data = {}
        }

        if (message.type == 'clbk' && message.id && clbks[message.id]){

            clbks[message.id](message.data, message.error)

            delete clbks[message.id]

            return

        }

        if(!message.action) return

        if (f.deep(actions, message.action))
            var promise = f.deep(actions, message.action).a(message, message.error)
            
            if (promise)
                promise.then(r => {

                    if (message.data.notification){
                        message.data.action = message.action
                        handleNotifications(message.data, r)
                    }

                })

        
        
    }

    var handleNotifications = function(message){

        message.payload || (message.payload = {})
        message.settings || (message.settings = {})

        if (handledNotifications[message.notification]) return
            handledNotifications[message.notification] = true

        function clickHandler() {
            var c = f.deep(actions, message.action + '.click') || f.deep(actions, `notification.${message.type}.click`)

            
            if (c) c(message.payload)
        }

        if(message.tap) {
            clickHandler();
        }

        else{

            if(message.payload.nothandle) return

            p.vm.$message({

                title : message.info.title,
                message : message.info.message,
                iconImg : message.info.icon || null,
                onClick : clickHandler,
                zIndex : 2900,
                supportHTML : true,
                wrapperClassName : "notificationWrapper",
                type : 'info'
        
            })

            if (message.settings.sound){
                /// TODO  insert new sound
    
                if (p.platform.voice && !p.platform.voice.playingnow()){
                    p.platform.voice.signal()
                }
            }
        }

        
       
        if(!message.ignoredb)
            p.vm.$store.commit('unseenincrease', 'notifications');

        _.each(message.settings.actions || [], function(a){

            handleMessages({
                action : a,
                data : message.payload
            })

        })

    }

    var handleStore = function(store, objects){

        console.log('handleStore', objects, p.vm.$store.state[store])

        f.retry(function(){

            return p.vm.$store.state[store]

        }, function(){

            if(!p.vm.$store.state[store]){
                return
            }

            if(_.isObject(p.vm.$store.state[store]) && typeof p.vm.$store.state[store].length != 'undefined'){

                if(!_.isArray(objects)) objects = [objects]

                var arr = p.vm.$store.state[store]
                var replace = {}
                var add = []
                var remove = {}

                _.each(objects, function(v, i){
                    var k = v.key || 'id'
                    if (v.remove) {
                        remove[k] || (remove[k] = {})
                        remove[k][v.id] = true

                        return
                    }

                    if(_.find(arr, function(o){
                        return o.id == v.id
                    })){
                        replace[v.id] = v

                        return
                    }

                    add.push(v)
                })

                console.log('handleStore2', store, arr, replace, add, remove)

                arr = _.filter(arr, function(o, i){

                    var r = _.find(remove, function(mp, key){
                        if(mp[o[key]]) return true
                    })  
                    
                    if(r) return false

                    if(replace[o.id]) arr[i] = replace[o.id]

                    return true
                })

                p.vm.$store.commit(store, arr.concat(add))

                return
            }

            console.log('_.isObject(p.vm.$store.state[store])', _.isObject(p.vm.$store.state[store]))

            if(_.isObject(p.vm.$store.state[store])){

                var obj = p.vm.$store.state[store]

                if(!_.isArray(objects)) objects = [objects]

                _.each(objects, function(object){
                    _.each(object, function(v, i){
                        obj[i] = v
                    })
                })
                

                p.vm.$store.commit(store, obj)

                return
            }

            

        }, 20, 1000)
    }

    var actions = {

        features : {
            a (message){

                var data = message.data

                if (data && data.features)
                    p.user.applyFeatures(data.features)

                return Promise.resolve()
            }
        }, 

       

        operation : {
            a (message){

                var data = message.data

                if (data && data.operation)
                    handleStore('operations', data.operation)

                return Promise.resolve()
            },
            click : function(payload) {
                p.vm.$router.push(`/operation?id=${payload.operation}`);
            }
        }, 

        connection : {
            a(message){

                var data = message.data

                if (data && data.connection)
                    handleStore('connections', data.connection)

                return Promise.resolve()
            },
            click : function(payload) {
                p.vm.$router.push(`/user/${payload.userInfo.id}`);
            }
        }, 

        notification : {
            operationsmany : {
                a (message){
    
                    return Promise.resolve()
                },
                click : function(payload) {
                    p.vm.$router.push(`/operations/`);
                }
            }, 
            payment : {
                a (message){
    
                    return Promise.resolve()
                },
                click : function(payload) {
                    p.vm.$router.push(`/payment?token=${payload.token}`);
                }
            }, 
            test : {
                a : function(message){
                    return Promise.resolve()
                },

                click : function(data){
                    p.vm.$router.push('/mynotifications')
                }
            },

            common : {
                a : function(message){
                    return Promise.resolve()
                },

                click : function(data){
                    p.vm.$router.push('/mynotifications')
                }
            },

            sessionforuser : {
                a : function(message){
                    return Promise.resolve()
                },

                click : function(data){
                    p.vm.$router.push('/session?id=' + data.session)
                }
            },

            calling : {
                a : function(message){
                    return Promise.resolve()
                },

                click : function(data){
                    p.vm.$router.push(data.info ? '/call/' + data.info.id : '/mycalls')
                }
            },

            missedcall : {
                a : function(message){

                    p.vm.$store.commit('unseenincrease', 'calls');

                    return Promise.resolve()

                },

                click : function(data){
                    p.vm.$router.push('/mycalls')
                }
            },

            patientAcceptedConnection : {
                a : function(message){
                    return Promise.resolve()
                },
                click : function(data) {
                    p.vm.$router.push('/docPatients');
                }
            },
            doctorPatientInviteIncoming : {
                a : function(message){
                    return Promise.resolve()
                },
                click : function(payload) {

                    p.vm.$router.push(`/invite?code=${payload.code}&docId=${payload.doctorId}`);
                    
                }
            },
            doctorCreatedRefill : {
                a : function(message){
                    return Promise.resolve()
                },
                click : function(payload) {
                    p.vm.$router.push(`/requestRefill?refillId=${payload.refillId}&docId=${payload.doctorId}`);
                }
            },
            patientRequestRefill : {
                a : function(message){
                    return Promise.resolve()
                },
                click : function(payload) {
                    p.vm.$router.push(`/viewRefillRequest?requestId=${payload.requestId}&patientId=${payload.patientId}`);
                }
            },
            doctorRefillRequestAction : {
                a : function(message){
                    return Promise.resolve()
                },
                click : function(payload) {
                    p.vm.$router.push(`/viewRefillRequest?requestId=${payload.requestId}&docId=${payload.doctorId}`);
                }
            },
        },

        usertypechanged: {
            a(message){
                if(typeof message.data.type != 'undefined'){

                    p.user.usertypechanged(message.data.type)

                }
                
                
                return Promise.resolve()
            }
        },

        notificationsCount : {
            a(message){

                p.user.unseen.all()
                
                return Promise.resolve()
            }
        },

        userOnline: {
            a(message){
                const online = true;
                p.vm.$store.dispatch('setUserStatusInLists', { ...message.data, online});

                _.each(self.clbks.setUserStatusInListsOnline, function(c){
                    c()
                })

                return Promise.resolve()
            }
        },

        userOffline: {
            a(message){
                const online = false;
                p.vm.$store.dispatch('setUserStatusInLists', { ...message.data, online});

                _.each(self.clbks.setUserStatusInListsOffline, function(c){
                    c()
                })

                return Promise.resolve()
            }
        },

        connectedWithUser: {
            a(message) {
                p.vm.$store.commit('icon', {
                    icon : 'success',
                    message : `Connected with ${message.data.user.firstname} ${message.data.user.lastname}`
                })

                const user = message.data.user;

                console.log("user", user)

                if (user.type) {
                    p.vm.$store.commit('addDoctor', user);
                } else {
                    p.vm.$store.commit('addPatient', user);
                }

                _.each(self.clbks.connectedWithUser, function(c){
                    c()
                })

                return Promise.resolve()
            }
        },

        emailconfirmed : {
            a : function(message){

                p.user.api.email.setconfirm(message.data)

                p.vm.$store.commit('icon', {
                    icon : 'success',
                    message : "Email was confirmed"
                })

                _.each(self.clbks.emailconfirmed, function(c){
                    c()
                })

                return Promise.resolve()
            }
        }, 
       
        signout : {
            a : function(message){
                if (message.data.signout) {
                    self.state.wssready.value = false
                }

                return Promise.resolve()
            }
        },

        registered : {
            a : function(message){

                if (message.data.registered) {
                    self.state.wssready.value = true
                }

                return Promise.resolve()
            }
        },

        newdeviceforcall : {
            a : function(message){
                    
                _.each(self.clbks.newdeviceforcall, function(c){
                    c(message.data)
                })

            }
        },

        calling : {
            a : function(message){
                if (message.data.peerid) {
                    
                    _.each(self.clbks.calling, function(c){
                        c(message.data.peerid, message.data)
                    })

                }
            }
        },

        declineRedirect: {
            a : function(message){
                if (message.data.peerid) {
                    
                    _.each(self.clbks.declineRedirect, function(c){
                        c(message.data.peerid, message.data)
                    })

                }

                return Promise.resolve()
            }
        },

        acceptRedirect: {
            a : function(message){
                if (message.data.peerid) {
                    
                    _.each(self.clbks.acceptRedirect, function(c){
                        c(message.data.peerid, message.data)
                    })

                }

                return Promise.resolve()
            }
        },

        redirectcall: {
            a : function(message){
                if (message.data.peerid && message.data.topeer) {
                    
                    _.each(self.clbks.redirectcall, function(c){
                        c(message.data.peerid, message.data)
                    })

                }

                return Promise.resolve()
            }
        },

        cancelcomminganotherdevice: {
            a : function(message){
                if (message.data.peerid) {
                    
                    _.each(self.clbks.cancelcomminganotherdevice, function(c){
                        c(message.data.peerid, message.data)
                    })

                }

                return Promise.resolve()
            }
        },

        cancelcomming: {
            a : function(message){
                if (message.data.peerid) {
                    
                    _.each(self.clbks.cancelcomming, function(c){
                        c(message.data.peerid, message.data)
                    })

                }

                return Promise.resolve()
            }
        },

        callstart : {
            a : function(message){
                if (message.data.peerid) {
                    
                    _.each(self.clbks.callstart, function(c){
                        c(message.data.peerid, message.data)
                    })

                }

                return Promise.resolve()
            }
        },

        callend : {
            a : function(message){

                if (message.data.peerid) {
                    
                    _.each(self.clbks.callend, function(c){
                        c(message.data.peerid, message.data)
                    })

                }

                return Promise.resolve()
            }
        },

        callcontext : {
            a : function(message){

                if (message.data.peerid) {
                    
                    _.each(self.clbks.callcontext, function(c){
                        c(message.data.peerid, message.data)
                    })

                }

                return Promise.resolve()
            }
        },

        lineisbusy : {
            a : function(message){

                if (message.data.peerid) {
                    
                    _.each(self.clbks.lineisbusy, function(c){
                        c(message.data.peerid, message.data)
                    })

                }

                return Promise.resolve()
            }
        },

        conflictcancelling : {
            a : function(message){


                if (message.data.peerid) {
                    
                    _.each(self.clbks.conflictcancelling, function(c){
                        c(message.data.peerid, message.data)
                    })

                }

                return Promise.resolve()
            }
        }
    }

    actions.notification.operation = actions.operation
    actions.notification.connection = actions.connection
   
    self.init = function(){

        self.state.opened.value = false

        if (rws){
            rws.close()
        }

        rws = new ReconnectingWebSocket(url, [], {
            minUptime : 60000,
            connectionTimeout : 12000,
            reconnectionDelayGrowFactor : 1,
            maxReconnectionDelay : 7000,
            minReconnectionDelay : 2000
        });
 
        rws.addEventListener('open', () => {

            self.state.opened.value = true
            self.lastevent = null

            _.each(self.clbks.open, function(o, i){
                o()
            })

        });

        rws.addEventListener('message', (message) => {

            handleMessages(message.data || "{}")

        });

        rws.addEventListener('close', (message) => {

            self.state.opened.value = false
            self.state.wssready.value = false

            p.platform.onlineListener.makeclbks('offline')

            if(self.doctor) self.doctor.stop()

        });

    }

    self.check = function(){
        if (rws){
            rws.send('0');
        }
    }

    self.api = {
        doctor : {
            worksession : {
                current : function(worksession, clbk){

                    authsend({
                        action : 'doctor.worksession.current',
                        worksession : worksession
                    }, clbk)

                },

                start : function(guid, clbk){

                    authsend({
                        action : 'doctor.worksession.start',
                        guid : guid
                    }, clbk)

                }, 

                end : function(guid, clbk){

                    authsend({
                        action : 'doctor.worksession.end',
                        guid : guid
                    }, clbk)

                }, 
            }
        }
    }

    self.isonline = function(){
        var now = moment()
        var l = now.diff(moment(self.lastevent), 'seconds') < 8

        return l
    }


    self.clbks = {
        calling : {},
        callend : {},
        callstart : {},
        lineisbusy : {},
        open : {},
        callcontext : {},
        emailconfirmed : {},
        connectedWithUser: {},
        setUserStatusInListsOnline: {},
        setUserStatusInListsOffline: {},
        newdeviceforcall : {},
        conflictcancelling : {},
        redirectcall : {},
        acceptRedirect : {},
        declineRedirect : {},
        cancelcomming : {},
        cancelcomminganotherdevice : {}
    }

    self.authsend = authsend
    self.send = send
    self.ping = ping
    self.signout = signout
    self.registration = registration
    self.handleMessages = handleMessages
    self.handleNotifications = handleNotifications
    self.actions = actions

    setInterval(function(){
        self.check()
    }, 5000)

    return self
}


export default WSS